import React, { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useFormik } from 'formik'

import Field from '../../../../../../components/Form/Field'
import EditForm from '../../../../../../features/components/Forms/EditForm'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { useEditSectionFormSubmit } from '../../../../../../hooks/formHooks/useEditSectionFormSubmit'

import { updateAd } from '../../../../../../modules/actions/ads'
import { selectedGoogleAdAccountSelector } from '../../../../../../modules/selectors/adAccounts'

import { formatValuesToFE, transformValuesToBE } from './formatters'

import { BUSINESS_NAME } from '../../../fields'
import { GOOGLE_PLATFORM } from '../../../../../../constants/selectLists/platformList'
import { CALL_TO_ACTION } from '../../../../../ReusableFormFields/CallToActionFields/fields'
import { googleAdsCallToActionList } from '../../../../../../constants/selectLists/googleAdsCallToActionList'
import { validationSchema } from './validation'
import { HISTORY_META_EDIT_SECTION } from '../../../../../../constants/changeHistory'

function NameSectionForm({ editItemData: ad, successSubmit, isInternalAd, title, ...formProps }) {
  const dispatch = useDispatch()

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)

  const { id: adId, ad_account_id: adAccountId } = ad
  const adAccount = adAccountId || selectedAdAccountId

  const initialValues = useMemo(() => formatValuesToFE(ad), [ad])

  const handleSubmit = useCallback(
    values => {
      const formattedUpdateItemData = {
        ...transformValuesToBE(values),
        account: adAccount,
        ...(isInternalAd && { internal: true }),
        meta: {
          [HISTORY_META_EDIT_SECTION]: title
        }
      }

      dispatch(updateAd(formattedUpdateItemData, adId, GOOGLE_PLATFORM))
    },
    [dispatch, adAccount, isInternalAd, adId, title]
  )

  const { onSubmit, manualSuccessSubmit } = useEditSectionFormSubmit({ initialValues, handleSubmit })

  const formik = useFormik({
    initialValues: initialValues,
    onSubmit,
    validationSchema,
    enableReinitialize: true
  })
  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      successSubmit={successSubmit || manualSuccessSubmit}
      {...formProps}
    >
      <Field formik={formik} name={BUSINESS_NAME} placeholder="Business name" autoComplete="off" />
      <Field placeholder="Call To Action" formik={formik} name={CALL_TO_ACTION} options={googleAdsCallToActionList} />
    </EditForm>
  )
}

export default NameSectionForm
